// @ts-nocheck
// Greif UI Kit = fill-copy
import * as React from "react";

const CopyFill: React.FC = () => {
    return (
        <svg focusable="false" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 12C5.63333 12 5.31944 11.8695 5.05833 11.6084C4.79722 11.3473 4.66667 11.0334 4.66667 10.6667V2.66671C4.66667 2.30004 4.79722 1.98615 5.05833 1.72504C5.31944 1.46393 5.63333 1.33337 6 1.33337H12C12.3667 1.33337 12.6806 1.46393 12.9417 1.72504C13.2028 1.98615 13.3333 2.30004 13.3333 2.66671V10.6667C13.3333 11.0334 13.2028 11.3473 12.9417 11.6084C12.6806 11.8695 12.3667 12 12 12H6ZM3.33333 14.6667C2.96667 14.6667 2.65278 14.5362 2.39167 14.275C2.13056 14.0139 2 13.7 2 13.3334V4.66671C2 4.47782 2.06389 4.31948 2.19167 4.19171C2.31944 4.06393 2.47778 4.00004 2.66667 4.00004C2.85556 4.00004 3.01389 4.06393 3.14167 4.19171C3.26944 4.31948 3.33333 4.47782 3.33333 4.66671V13.3334H10C10.1889 13.3334 10.3472 13.3973 10.475 13.525C10.6028 13.6528 10.6667 13.8112 10.6667 14C10.6667 14.1889 10.6028 14.3473 10.475 14.475C10.3472 14.6028 10.1889 14.6667 10 14.6667H3.33333Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(CopyFill);
